import {connect} from "redux-vue";
import classNames from "classnames";
import SlideTemplate from "./SlideTemplate";
import * as appActions from "../actions/app";
import * as actionsActions from "../actions/actions";
import {resetScrollConfig, stripTags} from "../helpers/tools";

const SummarySlide = {
  props: ['app', 'actions', 'goBack', 'goTo', 'fetchActions', 'fetchSummary'],

  mounted() {
    this.fetchActions();
    this.fetchSummary();
    resetScrollConfig();
  },

  methods: {
    handleGoTo(slide) {
      return () => this.goTo(slide);
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    return (
      <SlideTemplate key={this.app.summaryCollection}>
        <div class="p-6 lg:p-10 lg:py-6">

          <div class="flex justify-end pb-3">
            <button type="button" onClick={this.goBack} class="rounded-full bg-brand-green-400 p-5 py-1 text-white uppercase text-sm font-bold focus:outline-none">
              Close
            </button>
          </div>

          <div class="lg:px-20">
            <p class="text-brand-blue-600 text-3xl lg:text-5xl font-bold mb-10 leading-none">
              Summary Review
            </p>

            {this.app.completedSuccess && (
              <fragment>
                <p class="text-xl lg:text-3xl font-bold mb-3">
                  Congratulations!
                </p>

                <p class="text-lg lg:text-2xl leading-snug">
                  You have reached your goal of all four locations reaching at least 80% adoption. The lessons learned
                  during this implementation will be applied to national level recommendations for rollout to the entire
                  country.
                  <br/><br/>
                  Scroll through the timeline below to review your choices, as well as some additional feedback.
                </p>
              </fragment>
            )}

            {this.app.completedError && (
              <p class="text-lg lg:text-2xl leading-snug">
                78 weeks have passed, and not all locations have reached at least 80% adoption.
                <br/><br/>
                Scroll through the timeline below to review your choices, as well as some additional feedback.
              </p>
            )}

            <ul>
              <li class="flex mt-16">
                <div class="w-5/12 lg:px-8">
                  <p class="font-bold text-sm lg:text-2xl">
                    Action Taken
                  </p>
                </div>
                <div class="w-2/12">
                  <div class="w-1 lg:w-2 bg-brand-gray-300 h-full mx-auto rounded-t"></div>
                </div>
                <div class="w-5/12 lg:px-8">
                  <p class="font-bold text-sm lg:text-2xl">
                    Feedback
                  </p>
                </div>
              </li>
              {this.app.summaryCollection.map(each => (
                <TimelineItem trophy={each.id}
                              leftContainerClassName={stripTags(each.actionHTML.length) < 200 ? 'lg:self-center' : null}>
                  <div class="text-xs lg:text-sm leading-tight mb-3 lg:mb-0" domPropsInnerHTML={each.actionHTML} />
                  {each.resultsHTML && (
                    <p slot="results" class="text-xs lg:text-sm leading-tight mb-3" domPropsInnerHTML={each.resultsHTML} />
                  )}
                  {each.feedbackHTML && (
                    <p slot="feedback" class="text-xs lg:text-sm leading-tight" domPropsInnerHTML={each.feedbackHTML} />
                  )}
                </TimelineItem>
              ))}
              <li class="flex mb-10">
                <div class="w-5/12">
                </div>
                <div class="w-2/12">
                  <div class="w-1 lg:w-2 bg-brand-gray-300 h-24 mx-auto rounded-b"></div>
                </div>
                <div class="w-5/12"></div>
              </li>
            </ul>

            <button type="button" onClick={this.handleGoTo('conclusion')} class="block mb-24 mx-auto rounded-full bg-brand-orange-700 text-white uppercase py-2 lg:py-1 px-8 lg:px-12 lg:text-2xl hover:bg-orange-700 focus:outline-none">
              Continue
            </button>

          </div>
        </div>
      </SlideTemplate>
    );
  }
};

function mapStateToProps(state) {
  return {
    app: state.simulation.app,
    actions: state.simulation.actions,
  };
}

function mapActionToProps(dispatch) {
  return {
    goBack: () => dispatch(appActions.goBack()),
    goTo: (slide) => dispatch(appActions.goTo(slide)),
    fetchSummary: () => dispatch(appActions.fetchSummary()),
    fetchActions: () => dispatch(actionsActions.fetchActions()),
  };
}

export default connect(mapStateToProps, mapActionToProps)(SummarySlide);

/**
 *
 * @type {{data(): *, methods: {toggleOpen(): void}, render(*): *, props: string[]}}
 */
const TimelineItem = {
  props: ['leftContainerClassName', 'trophy'],

  data() {
    return {
      open: false,
    }
  },

  methods: {
    toggleOpen() {
      this.open = !this.open;
    }
  },

  render(h) {
    const menuClassName = classNames(
      "mdi text-lg lg:text-3xl leading-none transform lg:-translate-x-2 lg:translate-y-px",
      this.open ? 'mdi-menu-down' : 'mdi-menu-right'
    );
    const leftContainerClassName = classNames("w-5/12 my-4 self-center lg:self-start", this.leftContainerClassName);
    const feedbackClassName = classNames("w-5/12 my-4 self-center", { 'lg:self-start': !this.open });

    return (
      <li class="flex">
        <div class={leftContainerClassName}>
          <div class="p-3 lg:p-8 lg:py-3 bg-brand-gray-300 flex items-start">
            {this.trophy && (
              <img src="/img/changemanagement/img-trophy-alt.svg" alt="" class="w-6 lg:w-8 mr-3"/>
            )}
            <div>
              { this.$slots.default }
              {this.$slots.results && (
                <button onClick={this.toggleOpen} type="button" class="flex items-center text-xs lg:text-sm font-bold focus:outline-none">
                  Results
                  <i class={menuClassName}></i>
                </button>
              )}
              {this.open && this.$slots.results}
            </div>
          </div>
        </div>
        <div class="w-2/12 relative">
          <div class="arrow-right absolute transform -translate-y-1/2 left-0" style="border-left-color: var(--brand-gray-300); top: 50%"></div>
          <div class="w-1 lg:w-2 bg-brand-gray-300 h-full mx-auto"></div>
          <div class="h-8 w-8 lg:h-16 lg:w-16 bg-blue-300 rounded-full absolute top-0 transform -translate-x-1/2 -translate-y-1/2" style="left: 50%; top: 50%;">
            <div class="w-full h-full flex items-center justify-center">
              <img src="/img/changemanagement/icn-checkmark-larger.svg" alt="" class="w-20"/>
            </div>
          </div>
          {this.$slots.feedback && (
            <div class="arrow-left absolute transform -translate-y-1/2 right-0" style="border-right-color: var(--brand-gray-300); top: 50%"></div>
          )}
        </div>
        {this.$slots.feedback && (
          <div class={feedbackClassName}>
            <div class="p-3 lg:p-8 lg:py-10 bg-brand-gray-300">
              {this.$slots.feedback}
            </div>
          </div>
        )}
      </li>
    )
  }
};
